// extracted by mini-css-extract-plugin
export default {"right":"Customers_right__JCML-"};